import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import AuthService from 'common/auth.service';
import { isEmpty } from 'lodash';
import { API_BASE_URL } from 'utils/constants';
import { getCurrentUserData } from 'utils/helper';

// Create an Apollo server
export const createApolloServer = () => {
  const dynamicLink = new ApolloLink((operation, forward) => {
    let moduleName;

    if (operation.operationName.toLowerCase()?.startsWith('admin')) {
      moduleName = operation.operationName.toLowerCase()?.split('_')[1];
    } else {
      moduleName = operation.operationName.toLowerCase()?.split('_')[0];
    }

    const { apiURL } = getCurrentUserData();

    let updatedApiUrl = API_BASE_URL;

    if (!isEmpty(apiURL) && updatedApiUrl.startsWith(API_BASE_URL)) {
      updatedApiUrl = updatedApiUrl.replace(API_BASE_URL, apiURL);
    }

    const httpLink = new HttpLink({
      uri: `${updatedApiUrl}/${moduleName}/graphql`,
      credentials: 'same-origin',
    });

    const linkChain = ApolloLink.from([httpLink]);
    return linkChain.request(operation, forward);
  });

  const authLink = setContext((_, { headers }) => {
    const { apiKey } = getCurrentUserData();
    const auth = new AuthService();
    const token = auth.getSessionCookie();
    return {
      headers: {
        ...headers,
        'x-api-key': apiKey,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  return new ApolloClient({
    link: ApolloLink.from([authLink, dynamicLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
      },
    },
  });
};
